/** Aparência dos selos e formatação dos valores (fora dos componentes, por causa do fast refresh). */
import type { MetaIndicador, Selo } from '@metaepi/shared';
import type { TipoStatus } from '../../components/ui';

export const TIPO_SELO: Record<Selo, TipoStatus> = {
  eliminacao: 'sucesso',
  ouro: 'sucesso',
  prata: 'info',
  bronze: 'info',
  abaixo: 'perigo',
  sem_dados: 'neutro',
  em_desenvolvimento: 'desenvolvimento',
};

const numero = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });

/** "95,3%" ou "2,5 por 1.000 NV". */
export function formatarValor(valor: number | null, meta: MetaIndicador): string {
  if (valor === null) return '—';
  return meta.escala === 100 ? `${numero.format(valor)}%` : `${numero.format(valor)} por 1.000 NV`;
}

/** "Eliminação ≤ 0,5 · Ouro ≤ 2,5 · Prata ≤ 5 · Bronze ≤ 7,5" */
export function descreverMeta(meta: MetaIndicador): string {
  const s = meta.sentido === 'menor' ? '≤' : '≥';
  const v = (n: number) => `${numero.format(n)}${meta.escala === 100 ? '%' : ''}`;
  return `Eliminação ${s} ${v(meta.eliminacao)} · Ouro ${s} ${v(meta.ouro)} · Prata ${s} ${v(meta.prata)} · Bronze ${s} ${v(meta.bronze)}`;
}

const milhar = new Intl.NumberFormat('pt-BR');

/** Contagem exibida: "1.210", ou "< 5" quando ocultada para os perfis agregados (D-049). */
export const formatarContagem = (v: string | null) =>
  v !== null && /^\d+$/.test(v) ? milhar.format(Number(v)) : (v ?? '—');
